import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  // Cambiar API
  constructor(private http: HttpClient) { }

  sendInvitation(idCompany: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/companies/${idCompany}/invite-user`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  resendInvitation(company: number, id_company_user: number) {
    const payload = {
      id_company_user: id_company_user
    };
    const url = `${AppSettings.API_URI}/companies/${company}/resend-invitation`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  verifyInvite(key: any, manager: any, payload: any) {
    let url = `${AppSettings.API_URI_V2}/verify/invitation/control?key=${key}`;
    if(manager) {
      url += `&man=${manager}`;
    }
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }
  
}
